import { connect } from 'react-redux';
import { isLoading } from 'helpers';
import {
  loadMaCisCreator,
  removeMaCisCreator,
  removeMaCisFiltersCreator,
  setMaCisFiltersCreator,
  setMaCisPageCreator,
  setMaCisPerPageCreator,
  setMaCisProfileCreator,
  setMaCisSortCreator,
} from '../../../../store/actionsCreators';
import ChangeRequest from '../../../../shared/ChangeRequest/ChangeRequest';

const mapStateToProps = ({ loading, ma, user }) => ({
  loading: isLoading(loading, 'LOAD_MA_CIS'),
  type: 'ma',
  list: ma.cis.changeRequests,
  userPermissions: user.userPermissions,
});

const mapDispatchToProps = (dispatch) => ({
  loadList: () => dispatch(loadMaCisCreator('changeRequests')),
  setPage: (payload) => dispatch(setMaCisPageCreator('changeRequests', payload)),
  setPerPage: (payload) => dispatch(setMaCisPerPageCreator('changeRequests', payload)),
  setSort: (payload) => dispatch(setMaCisSortCreator('changeRequests', payload)),
  setFilters: (payload) => dispatch(setMaCisFiltersCreator('changeRequests', payload)),
  removeFilters: () => dispatch(removeMaCisFiltersCreator('changeRequests')),
  setProfile: (payload) => dispatch(setMaCisProfileCreator('changeRequests', payload)),
  removeChangeRequest: (payload) => dispatch(removeMaCisCreator('changeRequests', payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ChangeRequest);
